import { http } from '../rest';

export function fetch(http, demo) {
  return {
    async execute() {
      try {
        if (demo) {
          return true;
        }
        const result = await http.get('/email_verified');
        return result.data;
      } catch (error) {
        if (error && error.response && error.response.status === 404) return false;
        throw error;
      }
    },
  };
}

export default fetch(http, process.env.DEMO);
